import React, { useReducer } from "react";
import { smReducer, initialState } from "./smReducer";
import { SMContext } from "./smContext";
import logger from "use-reducer-logger";

export const SMProvider = ({ children }) => {
  const [state, dispatch] = useReducer(logger(smReducer), initialState);
  return <SMContext.Provider value={[state, dispatch]}>{children}</SMContext.Provider>;
};
